import React from 'react';
import styled from 'styled-components';
import ConfigControl from '../../../components/ConfigControl';
import { MonitorConfig } from '../../../helpers/constants';
import Column from './common/Column';

import LongStyledButton from './common/LongStyledButton';
import MonitorLabel from './common/MonitorLabel';
import Row from './common/Row';

export interface ICSRAAreaProps {
  currentConfig: string;
}
const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;
const StyledButton = styled.div`
  background-color: gray;
  color: white;
  width: 46%;
  padding-left: 2px;
  border: solid 1px white;
`;
const CustomRow = styled(Row)`
  justify-content: space-around;
`;

export default function CSRAArea(props: ICSRAAreaProps) {
  const { currentConfig } = props;
  return (
    <Container>
      <ConfigControl elementFor={MonitorConfig.SONAR} config={currentConfig}>
        <LongStyledButton
          style={{ width: '46%' }}
          field="csra-info-area-1"
          endWithColon={false}
        />
        <LongStyledButton
          style={{ width: '46%' }}
          field="csra-info-area-2"
          endWithColon={false}
        />
        <LongStyledButton
          style={{ width: '46%' }}
          field="csra-info-area-3"
          endWithColon={false}
        />
        <LongStyledButton
          style={{ width: '46%' }}
          field="csra-info-area-4"
          endWithColon={false}
        />
        <LongStyledButton
          style={{ width: '46%' }}
          field="csra-info-area-5"
          endWithColon={false}
        />
        <LongStyledButton
          style={{ width: '46%' }}
          field="csra-info-area-6"
          endWithColon={false}
        />
        <LongStyledButton
          style={{ width: '46%' }}
          field="csra-info-area-7"
          endWithColon={false}
        />
        <LongStyledButton
          style={{ width: '46%' }}
          field="csra-info-area-8"
          endWithColon={false}
        />
      </ConfigControl>
      <ConfigControl
        elementFor={[
          MonitorConfig.TACTICO,
          MonitorConfig.SISTEMA,
          MonitorConfig.LINK,
        ]}
        config={currentConfig}
      >
        <LongStyledButton field="csra-info-area-1" endWithColon={false} />
        <LongStyledButton field="csra-info-area-2" endWithColon={false} />
        <LongStyledButton field="csra-info-area-3" endWithColon={false} />
        <LongStyledButton field="csra-info-area-4" endWithColon={false} />
        <LongStyledButton field="csra-info-area-5" endWithColon={false} />
        <LongStyledButton field="csra-info-area-6" endWithColon={false} />
        <LongStyledButton field="csra-info-area-7" endWithColon={false} />
        <LongStyledButton field="csra-info-area-8" endWithColon={false} />
        <LongStyledButton field="csra-info-area-9" endWithColon={false} />
        <LongStyledButton field="csra-info-area-10" endWithColon={false} />
        <LongStyledButton field="csra-info-area-11" endWithColon={false} />
        <LongStyledButton field="csra-info-area-12" endWithColon={false} />
      </ConfigControl>
      <ConfigControl elementFor={[MonitorConfig.WEAPON]} config={currentConfig}>
        <Column width="33%">
          <LongStyledButton
            style={{ width: '100%' }}
            field="csra-info-area-1"
            endWithColon={false}
          />
          <LongStyledButton
            style={{ width: '100%' }}
            field="csra-info-area-2"
            endWithColon={false}
          />
          <LongStyledButton
            style={{ width: '100%' }}
            field="csra-info-area-3"
            endWithColon={false}
          />
          <LongStyledButton
            style={{ width: '100%' }}
            field="csra-info-area-4"
            endWithColon={false}
          />
        </Column>
        <Column width="66%">
          <LongStyledButton
            style={{ width: '100%' }}
            field="csra-info-area-5"
            endWithColon={false}
          />
          <CustomRow>
            <Column width="50%">
              <LongStyledButton
                style={{ width: '100%' }}
                field="csra-info-area-6"
                endWithColon={false}
              />
              <CustomRow>
                <Column width="33%">
                  <LongStyledButton
                    style={{ width: '100%' }}
                    field="csra-info-area-7"
                    endWithColon={false}
                  />
                </Column>
                <Column width="33%">
                  <LongStyledButton
                    style={{ width: '100%' }}
                    field="csra-info-area-9"
                    endWithColon={false}
                  />
                </Column>
                <Column width="33%">
                  <LongStyledButton
                    style={{ width: '100%' }}
                    field="csra-info-area-11"
                    endWithColon={false}
                  />
                </Column>
              </CustomRow>
              <CustomRow>
                <Column width="33%">
                  <LongStyledButton
                    style={{ width: '100%' }}
                    field="csra-info-area-8"
                    endWithColon={false}
                  />
                </Column>
                <Column width="33%">
                  <LongStyledButton
                    style={{ width: '100%' }}
                    field="csra-info-area-10"
                    endWithColon={false}
                  />
                </Column>
                <Column width="33%">
                  <LongStyledButton
                    style={{ width: '100%' }}
                    field="csra-info-area-12"
                    endWithColon={false}
                  />
                </Column>
              </CustomRow>
            </Column>

            <Column width="50%">
              <LongStyledButton
                style={{ width: '100%' }}
                field="csra-info-area-13"
                endWithColon={false}
              />
              <CustomRow>
                <Column width="33%">
                  <LongStyledButton
                    style={{ width: '100%' }}
                    field="csra-info-area-14"
                    endWithColon={false}
                  />
                </Column>
                <Column width="33%">
                  <LongStyledButton
                    style={{ width: '100%' }}
                    field="csra-info-area-16"
                    endWithColon={false}
                  />
                </Column>
                <Column width="33%">
                  <LongStyledButton
                    style={{ width: '100%' }}
                    field="csra-info-area-18"
                    endWithColon={false}
                  />
                </Column>
              </CustomRow>
              <CustomRow>
                <Column width="33%">
                  <LongStyledButton
                    style={{ width: '100%' }}
                    field="csra-info-area-15"
                    endWithColon={false}
                  />
                </Column>
                <Column width="33%">
                  <LongStyledButton
                    style={{ width: '100%' }}
                    field="csra-info-area-17"
                    endWithColon={false}
                  />
                </Column>
                <Column width="33%">
                  <LongStyledButton
                    style={{ width: '100%' }}
                    field="csra-info-area-19"
                    endWithColon={false}
                  />
                </Column>
              </CustomRow>
            </Column>
          </CustomRow>
        </Column>
      </ConfigControl>
    </Container>
  );
}
